import { render, staticRenderFns } from "./VerticalStepper.vue?vue&type=template&id=1788f4be&"
import script from "./VerticalStepper.vue?vue&type=script&lang=js&"
export * from "./VerticalStepper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports